import { Directive, HostBinding, Output,EventEmitter, HostListener} from '@angular/core';

@Directive({
  selector: '[appDnd]'
})
export class DndDirective {

  // constructor() { }

@HostBinding('class.fileover') fileOver: boolean;
@Output() fileDropped =  new EventEmitter<any>()

// dragover listener
@HostListener('dragover', ['$event']) onDragOver(evt){
  evt.preventDefault()
  evt.stopPropagation()
  this.fileOver = true
}
// drag leave listener
@HostListener('dragleave', ['$event']) onDragLeave(evt){
  evt.preventDefault()
  evt.stopPropagation()
  this.fileOver = false
}

@HostListener('drop', ['$event']) ondrop(evt){
  evt.preventDefault()
  evt.stopPropagation()
  this.fileOver = false
  let files  = evt.dataTransfer.files
  if (files.length > 0){
    this.fileDropped.emit(files)
    }
  }

}
